import { Component, Input } from '@angular/core';

import { ITableColumnDetailsType, SharedCSSPropertyName, TextType } from '@app/eds';

export interface IAppointmentDetails {
  poNumber: string;
  poDetails: any[];
}

@Component({
  selector: 'app-labelled-table',
  templateUrl: './labelled-table.component.html',
  styleUrls: ['./labelled-table.component.scss']
})
export class LabelledTableComponent {
  // array of objects to be displayed in each row of the table
  @Input() data!: any[];

  // the column names of the table
  @Input() displayedColumnDetails: ITableColumnDetailsType[] = [];

  // boolean to specify if the first coulmn to be customised or not
  @Input() active = false;

  // array of footers
  @Input() footers: string[] = [];

  // boolean to specify if the footers to be shown
  @Input() showFooter = true;

  //To specify the class name of the table header
  @Input() headerClassName!: string;

  // To specify the class name of the table footer.
  @Input() footerClassName!: string;

  // To specify the class name of the table rows.
  @Input() rowClassName!: string;

  // The string that needs to be displayed in the title field
  @Input() title!: string;

  // The string that needs to be displayed in the subtitle field
  @Input() subtitle!: string;

  // To specify the padding between the title and the subtitle for the table
  @Input() subtitlePadding!: string;

  // To specify the font style of the title field
  @Input() titleFontStyle!: TextType;

  // To specify the font style of the subtitle field
  @Input() subtitleFontStyle!: TextType;

  // To specify the margin between the table and the label for the table
  @Input() tableMargin!: string;

  // To specify if the title requires an icon
  @Input() showIcon = false;

  // To specify the icon type
  @Input() iconType!: string;

  // To specify the icon color
  @Input() iconColor!: string;

  /**
   * This function is called to give custom style to the table
   *
   * @returns custom styles for the table
   */
  getCustomStyles = () => {
    const styles: { [key: string]: string } = {};
    this.tableMargin && (styles[SharedCSSPropertyName.PADDING_TOP] = this.tableMargin);
    return styles;
  };
}
